var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-bank-modal-container"},[(_vm.visibleModal && _vm.loaded)?_c('table-content',{attrs:{"responses":_vm.responses,"payments":_vm.payments.items}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }